import React, { useState, useEffect, Fragment } from "react";
import OtpInput from "react-otp-input";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseURL, vapidKey } from "../../../constants/Api";
import { useDispatch } from "react-redux";
import { setAppUserName } from "../../../slices/LayoutSlice";
import { setLoggedMobileNo } from "../../../utils/util";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase/Firebase";

function Verify({ phoneNumber, source, countryCode }) {
  const [value, setValue] = useState([]);
  const [otpError, setOtpError] = useState(false);
  const [loading, setlLoading] = useState(false);
  const numberStr = phoneNumber.toString();
  const prefix = numberStr.slice(0, 2);
  const suffix = numberStr.slice(-2);
  const [errorMsg, setErrorMsg] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const maskedNumber = `${prefix}******${suffix}`;
  const [deviceToken, setDeviceToken] = useState(localStorage.getItem('firebaseDeviceToken')?? "");

  const dispatch = useDispatch()
  // const [loadings, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  const handleFinish = (otp) => {
    setErrorMsg("");
    const payload = otp || value; // Use the provided otp or the current value
    const otpArray = Array.isArray(payload) ? payload : Array.from(payload);
    const otpString = otpArray.join(""); // Join the array elements
    console.log(otpString);
    if (/^[0-9]*$/.test(otpString)) {
      verifyOtp(otpString);
    } else {
      setTimeout(() => {
        setOtpError(false);
      }, 3000);
      setOtpError(true);
    }
  };

  const handleAutoSubmit = (otp) => {
    if (otp.length === 4) {
      handleFinish(otp);
    }
  };

  const generateToken = async () => {
    // const prefix = "WEBTOKEN";
    // const currentTime = new Date().getTime().toString().slice(-11);
    // const uniqueID = prefix + currentTime;
    // return uniqueID;

    const token = await getToken(messaging, {
      vapidKey,
    });
    console.log("Token Gen", token);
    // return token;
    setDeviceToken(token);
  };

    useEffect(()=>{
      if(deviceToken) generateToken();
    },[]);

  const generateDeviceId = () => {
    const prefix = "WEBID";
    const currentTime = new Date().getTime().toString().slice(-11);
    const uniqueID = prefix + currentTime;
    return uniqueID;
  };

  const verifyOtp = async (otpValue) => {
    console.log(otpValue);
    let data = JSON.stringify({
      mobile: phoneNumber,
      otp: otpValue,
      deviceId: generateDeviceId(),
      deviceToken: deviceToken // await generateToken(), 
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/api/OtpVerificationV21`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setlLoading(true);
      const response = await axios.request(config);
      console.log(response.data);
      if (response.data.success) {
        setlLoading(false);
        setIsOtpVerified(true);
        dispatch(setAppUserName(response.data?.user_name))
        localStorage.setItem("phone_no", phoneNumber);
        setLoggedMobileNo(phoneNumber)
        navigate("../hotel-list",{state:{
          source : source
        }});
      } else {
        if (response.data.message == "OTP is not valid.") {
          setErrorMsg("OTP mismatched");
        }
        setlLoading(false);
      }
    } catch (error) {
      setlLoading(false);
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const sentOtp = async () => {
    if (timer > 0) return;
    setValue('');
    setErrorMsg('');
    let data = JSON.stringify({
      mobile: phoneNumber,
      country_code: countryCode
    });

    let config = {
      method: "post",
      url: `${baseURL}/api/sendloginOtpSMSV21`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setlLoading(true);
      const response = await axios.request(config);
      console.log(response.data);
      if (response.data.success) {
        setlLoading(false);
        startTimer(); 
      }
    } catch (error) {
      setlLoading(false);
      console.log(error);
    }
  };

  const startTimer = () => {
    let timeLeft = 30; // Timer duration in seconds
    setTimer(timeLeft);

    const countdown = setInterval(() => {
      timeLeft -= 1;
      setTimer(timeLeft);

      if (timeLeft <= 0) {
        clearInterval(countdown); // Stop the timer
      }
    }, 1000);
  };

  // useEffect(() => {
  //   if (isOtpVerified) {
  //     navigate("../booking-id");
  //     console.log("Navigate to booking-id page");
  //   }
  // }, [isOtpVerified]);

  return (
    <>
      <div className="text-center sm:px-5 py-5 px-0">
        <div className="heading">Enter Code Sent to your Phone</div>
        <div className="sent">We sent it to number {maskedNumber}</div>
        <div className="sm:mt-6 mt-3  relative mx-auto sm:w-[55%] flex sm:justify-center justify-start inputParent">
          <OtpInput
            className="otp justify-center"
            value={value}
            onChange={(otp) => {
              setValue(otp);
              handleAutoSubmit(otp);
            }}
            numInputs={4}
            separator={<span>-</span>}
            isInputNum={true}
            renderInput={(props) => <input {...props} type="tel" />}
          />
          {otpError && (
            <div className="absolute font-medium text-xs text-red-500 -bottom-6 left-1/2 translate-x-1/2">
              Invalid Otp
            </div>
          )}
          {errorMsg && (
            <div className="absolute font-medium text-xs text-red-500 -bottom-5 left-1/2 -translate-x-1/2">
              {errorMsg}
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-center code  text-left">
        Don’t Recieve Code?{" "}
        <span onClick={timer === 0 ? sentOtp : null}  className={`req ml-1 cursor-pointer ${timer > 0 ? "text-gray-500 cursor-not-allowed" : ""}`}
      style={{ pointerEvents: timer > 0 ? "none" : "auto" }}>
          {timer > 0 ? `Request Again in ${timer}s` : "Request Again"}
        </span>
        {loading ? <div className="loader ml-4"></div> : null}
      </div>
    </>
  );
}

export default Verify;
